import {AttrsSchema, Component} from 'panel';

import {userDetailsStore} from 'common/report/stores/user-details';
import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {getMpContext} from 'common/mp-context';

import {ClassificationAccessOnlyBannerAttrs, ClassificationAccessOnlyBannerState} from './types';
import template from './index.jade';
import css from './index.styl?inline';

export class ClassificationAccessOnlyBanner extends Component<
  ClassificationAccessOnlyBannerState,
  ClassificationAccessOnlyBannerAttrs
> {
  static get attrsSchema(): AttrsSchema<ClassificationAccessOnlyBannerAttrs> {
    return {
      ...super.attrsSchema,
      'app-name': `string`,
      'project-id': `number`,
      'workspace-id': `number`,
    };
  }

  constructor() {
    super();
    userDetailsStore.subscribe(() => this.userDetailsUpdate()).fetch();
  }

  get config() {
    return {
      css,
      template,
      useShadowDom: true,
      defaultState: {
        canManageClassifiedData: false,
      },
      helpers: {},
    };
  }

  userDetailsUpdate() {
    const details = userDetailsStore.value;
    const projectId = this.attr(`project-id`) || getMpContext().projectId;

    const canManageClassifiedData = details.projects[projectId]?.permissions?.includes(`manage_sensitive_data`);
    this.update({canManageClassifiedData});
  }
}

export const ClassificationAccessOnlyBannerEl = defineAndMakeJsxFactory(
  `classification-access-only-banner`,
  ClassificationAccessOnlyBanner,
);
